/* Procedural zipper "zkkk" — rapid filtered-noise crackle, no audio assets needed. */
let ctx = null;
let enabled =
    typeof localStorage !== "undefined" ? localStorage.getItem("urwan_sound") !== "off" : true;

function ensureCtx() {
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        try {
            ctx = new AC();
        } catch {
            return null;
        }
    }
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
}

if (typeof window !== "undefined") {
    window.addEventListener("pointerdown", () => ensureCtx(), { once: true, passive: true });
}

export function isSoundOn() {
    return enabled;
}

export function toggleSound() {
    enabled = !enabled;
    try {
        localStorage.setItem("urwan_sound", enabled ? "on" : "off");
    } catch {}
    return enabled;
}

export function playZip({ rate = 1, volume = 0.09 } = {}) {
    if (!enabled) return;
    const ac = ensureCtx();
    if (!ac || ac.state !== "running") return;
    const dur = 0.3 / rate;
    const buffer = ac.createBuffer(1, Math.ceil(ac.sampleRate * dur), ac.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
    const src = ac.createBufferSource();
    src.buffer = buffer;
    const bp = ac.createBiquadFilter();
    bp.type = "bandpass";
    bp.Q.value = 1.6;
    bp.frequency.setValueAtTime(1300 * rate, ac.currentTime);
    bp.frequency.exponentialRampToValueAtTime(3400 * rate, ac.currentTime + dur);
    const gain = ac.createGain();
    const teeth = 24;
    gain.gain.setValueAtTime(0.0001, ac.currentTime);
    for (let i = 0; i < teeth; i++) {
        const t0 = ac.currentTime + (i / teeth) * dur;
        const v = volume * (0.45 + (i / teeth) * 0.55);
        gain.gain.setValueAtTime(v, t0);
        gain.gain.exponentialRampToValueAtTime(0.0001, t0 + (dur / teeth) * 0.72);
    }
    src.connect(bp).connect(gain).connect(ac.destination);
    src.start();
}
